<div class="main-page-content">
  <div class="main-page-content-block">
    <div class="float-end">

      <p *ngIf="loading" role="status">Loading permissions...</p>
      
    </div>
    <h1 class="content-heading-font">{{ currentItem?.BusinessName ||'Client' }} Permissions</h1>

    
    <div *ngIf="currentItem">
      <div class="row">
        <div class="col mb-3">
          <label for="selectPermission">Permission</label>
          <select id="selectPermission" class="form-control" name="selectPermission"
                  [ngModel]="currentPermission?.PermissionID"
                  (ngModelChange)="selectPermission($event)"
                  [disabled]="loading || saving">
            <option [ngValue]="undefined">Select a permission</option>
            <option *ngFor="let permission of permissions" [ngValue]="permission.PermissionID">
              {{permission.Category}} - {{permission.Permission}}: {{permission.Description}}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-2" *ngIf="currentPermission && assignmentsLoaded">
        <div class="col-md-6 mb-3">
          <label for="permissionUsers">Users</label>
          <p-autoComplete inputId="permissionUsers" name="permissionUsers"
                          [(ngModel)]="selectedUsers" [suggestions]="filteredUsers"
                          (completeMethod)="searchUsers($event)"
                          optionLabel="UserName" dataKey="ID" [multiple]="true"
                          [forceSelection]="true" [dropdown]="true" [minLength]="0"
                          [disabled]="saving" styleClass="w-100" placeholder="Search users">
            <ng-template pTemplate="item" let-user>
              {{user.FirstName}} {{user.LastName}} - {{user.UserName}}
              {{user.Hidden ? '(Hidden)' : ''}} {{user.Inactive ? '(Inactive)' : ''}}
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="col-md-6 mb-3">
          <label for="permissionRoles">Roles</label>
          <p-autoComplete inputId="permissionRoles" name="permissionRoles"
                          [(ngModel)]="selectedRoles" [suggestions]="filteredRoles"
                          (completeMethod)="searchRoles($event)"
                          optionLabel="Role" dataKey="RoleID" [multiple]="true"
                          [forceSelection]="true" [dropdown]="true" [minLength]="0"
                          [disabled]="saving" styleClass="w-100" placeholder="Search roles">
            <ng-template pTemplate="item" let-role>
              {{role.Role}} - {{role.Description}} {{role.Hidden ? '(Hidden)' : ''}}
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      <div class="row" *ngIf="currentPermission">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="button" id="btnSave"
                  [class.button-loading]="saving" [disabled]="loading || saving || !assignmentsLoaded"
                  (click)="save()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
